import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent implements OnInit {
  @Input() public message;
  @Input() public forModal: any;
  @Input() public type;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    public _router: Router,
    private authService: AuthService) { }

  ngOnInit() {
  }

  closeDialog() {
    this.activeModal.close();
    if (this.type && this.type === 'verifiedErr') {
      this._router.navigate(['/settings'], {
        queryParams: {
          type: "verification",
        }
      });
    }
  }

  openForgotModal() {
    this.modalService.dismissAll();
    this.authService.modalOpen('ForgotPasswordComponent', '', true);
  }

}
